import { useMemo } from 'react';

import { ExcelEntityConfig, ExcelFilesView } from '../ExcelFilesView';
import { useApiView } from './useApiView';

export const useExcelFilesView = (workspaceId: string, organisationId: string, config: ExcelEntityConfig) => {
  const configKey = config.entityType === 'forecast' ? config.forecastId : config.entityType;

  const viewInstance = useMemo(
    () => new ExcelFilesView(workspaceId, organisationId, config),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [workspaceId, organisationId, configKey]
  );

  const view = useApiView(viewInstance);

  return { viewInstance, ...view.state };
};
